module.exports = __webpack_public_path__ + "static/media/Kingswood.8386fc65.pdf";